// feature/litisoft-mandatory-fields-v1 — sprint83 / sprint83.2.
//
// Shown when POST /api/cases/:id/marcar-contestada returns
//   400 { error: "litisoft_incomplete", missing_fields: [...] }
//
// sprint83.2 — the 3 mandatory dropdowns now live inline in the case
// detail view (LitisoftMandatoryInline). The "Ir a la sección" button
// closes the contestada modal and smooth-scrolls to that section
// instead of redirecting to a separate LITISOFT panel.

import React from "react";
import CenteredModal from "./CenteredModal";
import { LITISOFT_FIELD_LABELS } from "./LitisoftFields";
import { scrollToLitisoftMandatorySection } from "./LitisoftMandatoryInline";

export default function LitisoftIncompleteModal({ open, onClose, missingFields = [], onGoToPanel }) {
  const labels = (missingFields || []).map((f) => LITISOFT_FIELD_LABELS[f] || f);
  function handleGoTo() {
    onGoToPanel?.();
    // Smooth-scroll after the contestada modal closes (next paint).
    setTimeout(scrollToLitisoftMandatorySection, 50);
  }
  return (
    <CenteredModal
      open={open}
      onClose={onClose}
      title="No puede marcar este caso como contestado todavía"
      size="md"
      footer={<>
        <button className="secondary" onClick={onClose}>Cerrar</button>
        <button onClick={handleGoTo}>Ir a la sección</button>
      </>}
    >
      <div style={{ fontSize: 13, marginBottom: 8 }}>
        Faltan los siguientes campos obligatorios:
      </div>
      <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, color: "var(--text-body)" }}>
        {labels.map((l, i) => <li key={i} style={{ marginBottom: 4 }}>{l}</li>)}
      </ul>
      <div className="muted" style={{ fontSize: 12, marginTop: 12 }}>
        Complételos en la sección <strong>“Datos LITISOFT obligatorios”</strong> más
        arriba en esta misma página y vuelva a intentar.
      </div>
    </CenteredModal>
  );
}
